<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template v-slot:item.regions="{ item }">
      {{ getRegionsColumnString(item.regions) }}
    </template>
  </entity-list-table>
</template>

<script>

  import NewsDataService from '@/services/api/NewsDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import { mapGetters } from 'vuex'
  import _ from 'lodash'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Новости',
        dataService: NewsDataService,
        createRouteName: 'Создать Новость',
        editRouteName: 'Новость',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Регионы', value: 'regions', align: 'start' },
          { text: 'Сортировка', value: 'sortOrder', align: 'center' },
        ],

        allowDelete: true,
        showStatusColumn: true,
      }
    },
    computed: {
      ...mapGetters({
        getTimezoneTitle: 'app/getTimezoneTitle',
      }),
    },
    methods: {
      getRegionsColumnString (regions) {
        if (_.isEmpty(regions)) {
          return ''
        }

        return regions.map((item) => item.name).join(', ')
      },
    },
  }
</script>
